import FinancialReportsBuilder from './builder'
import FinancialReportsGator from './gator'
import FinancialReportsCtct from './ctct'
import FinancialReportsEmailMarketing from './email-marketing'
import FinancialReportsSocial from './social'
import FinancialReportsWordpressCM from './wordpress-cm'
import FinancialReportsWordpressEditor from './wordpress-editor'

export default {
  ...FinancialReportsBuilder,
  ...FinancialReportsGator,
  ...FinancialReportsCtct,
  ...FinancialReportsEmailMarketing,
  ...FinancialReportsSocial,
  ...FinancialReportsWordpressCM,
  ...FinancialReportsWordpressEditor
}
